module.exports = __webpack_public_path__ + "static/img/mode1.99883ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/mode1.png
// module id = GX1T
// module chunks = 1